import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Pricing_Engine_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_PRICINGENGINE_ID:   {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Pricing Engine Id',    columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {}},
    PRICINGENGINE_ID:      {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Pricing Engine Id',       columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PRICINGENGINE_NAME:    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Pricing Engine Name',     columnResourceName: 'colName',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    WB_CUSTH_ID:           {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Cust Id',              columnResourceName: 'colCustId',           alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_PRDH_ID:            {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Prd Id',               columnResourceName: 'colPrdId',            alignment: HorizAlignment.Left},  domainOptions: {}},
    CREATED_DTTS:          {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',            columnResourceName: 'colCreatedDate',      alignment: HorizAlignment.Left},  domainOptions: {}},
    MODIFIED_DTTS:         {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',            columnResourceName: 'colModifiedDate',     alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_IND:           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Deleted Ind',             columnResourceName: 'colDeletedInd',       alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_DT:            {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Deleted Date',            columnResourceName: 'colDeleted_Date',     alignment: HorizAlignment.Left},  domainOptions: {}}
};

const PricingEngineSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PRICINGENGINE_ID',
        id_ui: 'PRICINGENGINE_ID',
        name: 'PRICINGENGINE_NAME'
    },

    searchProviderFields: vUI_Pricing_Engine_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Pricing_Engine_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const PricingEngineSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PricingEngineSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PRICINGENGINE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PRICINGENGINE_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PRICINGENGINE_ID', 'PRICINGENGINE_NAME', 'WB_CUSTH_ID', 'WB_PRDH_ID', 'CREATED_DTTS', "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider:PricingEngineSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PricingEngineSearch: ISearch = {
    searchName: "Find Pricing Engine",
    renderOptions: {ui5ResourceId: "PricingEngineSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PricingEngineSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("PricingEngineBO", "PricingEngine", PricingEngineSearch, "Pricing Engine Search")

export {PricingEngineSearch}